export interface LoginWithGoogleResponse {
  newUser: boolean;
  token: string;
  refreshToken: string;
  userId: string;
  email: string;
}

export enum LoginWithGoogleResponseStatusCodes {
  BadRequest = 400,
  Failed = 401,
  Forbidden = 403,
}
